import { Row, Col } from "reactstrap"
import { useNavigate } from "react-router-dom"
import ComponentBackButton from "../../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton"
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import InfoCard from "../../../../common/AdminCommonComponents/InfoCard/InfoCard"

const WarehouseDetail = ({ setShowWarehouseDetails }) => {
  const navigate = useNavigate()

  const generalInformationData = [
    { label: "Warehouse ID", value: "#1234" },
    { label: "Artner Name", value: "#123" },
    { label: "Location", value: "#1234" },
    { label: "Capacity", value: "#1234" },
    { label: "Available Space", value: "#1234" },
    { label: "Status", value: "#1234" },
    { label: "Contact Person", value: "#1234" },
    { label: "Contact Email", value: "#1234" },
    { label: "Contact Phone", value: "#1234" },
  ]

  const auditTrialData = [
    { label: "Date Added", value: "02/01/25 02:18 AM" },
    { label: "Last Modified", value: "02/01/25 02:18 AM" },
    { label: "Modified by", value: "Admin name" },
  ]

  const handleEditClick = () => {
    navigate("/fbm-management/edit-warehouse-detail")
  }

  return (
    <div className="bg-white py-3 px-5 mt-3 shadow">
      <ComponentBackButton onClick={() => setShowWarehouseDetails(false)} />

      <div className="fw-semibold fs-4 text-center">Brand Overview</div>
      <Row className="row-cols-1 row-cols-xl-3">
        <Col>
          <InfoCard title="General Information" headerColor="#FBBD34" data={generalInformationData} />
        </Col>
      </Row>
      <Row className="row-cols-1 row-cols-xl-3 mt-3">
        <Col>
          <InfoCard title="Audit Trial" headerColor="#9B9B9B" data={auditTrialData} />
        </Col>
      </Row>

      <div className="text-center d-flex justify-content-end mt-3">
        <div className="d-grid gap-2">
          <DynamicButton theme="sky-blue">Change Status</DynamicButton>
          <DynamicButton theme="orange" onClick={handleEditClick}>
            Edit Detail
          </DynamicButton>
        </div>
      </div>
    </div>
  )
}

export default WarehouseDetail
